// import React, { useState, useRef } from "react";
// import "./Discount.css";
// // import CreateContact from "./CreateContact";
// // import FundAccount from "./FundAccount";
// import { Link } from "react-router-dom";
// import Cancelandrefundpage from "./Cancelandrefundpage";
// import Foodsettlementpage from "./Foodsettlementpage";

// import Fooddataoverview from "./Fooddataoverview";
// // import DeliverySettelment from "./DeliverySettelment"
// const Foodaccounts = () => {
//     const [activeTab, setActiveTab] = useState("Cancel/Refund");


//     const tabContent = {
//         // Profile: <SuperProfile />,
//         // Overview: <Fooddataoverview />,
//         // "Subscription": <ClientSubcription />,
//         "Cancel/Refund": <Cancelandrefundpage />,
//         "Vendor Settlement": <Foodsettlementpage />,
//         // "Delivery Settlement": <DeliverySettelment />,
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-2"></div>
//                 <div className="col-lg-10 food-accounts-data-scroll" style={{ height: "70vh", overflowY: "auto", scrollbarWidth: "none" }}>
//                     <p
//                         className="breadcrumb maamaas-home-bredcum or7"
//                         style={{
//                             position: "fixed",
//                             top: "56px",
//                             left: "1vw",
//                             width: "100%",
//                             backgroundColor: "#fff",
//                             padding: "10px 0",
//                             fontSize: "18px",
//                             fontWeight: "bold",
//                             textAlign: "center",
//                             margin: 0,
//                         }}
//                     >
//                         <Link
//                             to="/Homes"
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Home
//                         </Link>

//                         <span className="separator"> &gt; </span>
//                         <span
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             <Link
//                                 // to="/digitalmenu&billing"
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Account_History
//                             </Link>
//                         </span>
//                         <span className="separator"> &gt; </span>
//                         <span
//                             style={{
//                                 color: "purple",
//                                 fontWeight: "bold",
//                                 textDecoration: "none",
//                             }}
//                         >
//                             Food & Beverages
//                         </span>
//                     </p>
//                     <div className="discount-container accounts-data" >
//                         <div
//                             style={{
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                                 position: "fixed",
//                                 top: "120px",
//                                 left: "55%",
//                                 transform: "translate(-45%, -50%)",
//                                 gap: "0px",
//                                 zIndex: 10,
//                                 width: "100vw",
//                                 maxWidth: "1200px",
//                                 flexWrap: "wrap",
//                                 padding: "10px 0",
//                             }}
//                             className="rorr row b2"
//                         >
//                             {Object.keys(tabContent).map((label) => (
//                                 <div
//                                     key={label}
//                                     className="col-lg-12 col-md-6 col-sm-12 col-12"
//                                     style={{
//                                         display: "flex",

//                                         marginBottom: "10px",
//                                         maxWidth: "200px",
//                                     }}
//                                 >
//                                     <button
//                                         onClick={() => setActiveTab(label)}
//                                         style={{

//                                             border: "none",
//                                             borderRadius: "10px",

//                                             width: "100%",
//                                             padding: "0 10px",
//                                             height: "40px",
//                                             backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
//                                             color: activeTab === label ? "#fff" : "#000",
//                                             fontWeight: "bold",
//                                             cursor: "pointer",
//                                             transition: "background-color 0.3s ease",
//                                             fontSize: "1rem",
//                                         }}
//                                     >
//                                         {label}
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>
//                         <div
//                             style={{
//                                 height: "95vh",
//                                 overflowY: "auto",
//                                 scrollbarWidth: "none",
//                                 paddingTop: "20px",
//                                 borderRadius: "8px",
//                                 marginTop: "0px",
//                             }}
//                             className="b1"
//                         >
//                             {tabContent[activeTab]}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Foodaccounts;























import React, { useState, useRef } from "react";
import "./Discount.css";
// import CreateContact from "./CreateContact";
// import FundAccount from "./FundAccount";
import { Link } from "react-router-dom";
import Cancelandrefundpage from "./Cancelandrefundpage";
import Foodsettlementpage from "./Foodsettlementpage";

import Fooddataoverview from "./Fooddataoverview";
// import DeliverySettelment from "./DeliverySettelment"
const Foodaccounts = () => {
    const [activeTab, setActiveTab] = useState("Cancel/Refund");


    const tabContent = {
        // Profile: <SuperProfile />,
        // Overview: <Fooddataoverview />,
        // "Subscription": <ClientSubcription />,
        "Cancel/Refund": <Cancelandrefundpage />,
        "Vendor Settlement": <Foodsettlementpage />,
        // "Delivery Settlement": <DeliverySettelment />,
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10 food-accounts-data-scroll" style={{ height: "85vh", overflowY: "auto", scrollbarWidth: "none" }}>
                    <p
                        className="breadcrumb maamaas-home-bredcum or7"
                        style={{
                            position: "fixed",
                            top: "56px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            padding: "10px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            <Link
                                
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Account_History
                            </Link>
                        </span>
                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Food & Beverages
                        </span>
                    </p>
                    <div className="discount-container accounts-data" >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "fixed",
                                top: "120px",
                                left: "55%",
                                transform: "translate(-45%, -50%)",
                                gap: "0px",
                                zIndex: 10,
                                width: "100vw",
                                maxWidth: "1200px",
                                flexWrap: "wrap",
                                padding: "10px 0",
                            }}
                            className="rorr row b2"
                        >
                            {Object.keys(tabContent).map((label) => (
                                <div
                                    key={label}
                                    className="col-lg-12 col-md-6 col-sm-12 col-12"
                                    style={{
                                        display: "flex",

                                        marginBottom: "10px",
                                        maxWidth: "200px",
                                    }}
                                >
                                    <button
                                        onClick={() => setActiveTab(label)}
                                        style={{

                                            border: "none",
                                            borderRadius: "10px",

                                            width: "100%",
                                            padding: "0 10px",
                                            height: "40px",
                                            backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
                                            color: activeTab === label ? "#fff" : "#000",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        {label}
                                    </button>
                                </div>
                            ))}
                        </div>
                        <div
                            style={{
                                height: "95vh",
                                overflowY: "auto",
                                scrollbarWidth: "none",
                                paddingTop: "20px",
                                borderRadius: "8px",
                                marginTop: "0px",
                            }}
                            className="b1"
                        >
                            {tabContent[activeTab]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Foodaccounts;
